import React, { Component } from "react";
import PageBannerStack from "../PageBannerStack/PageBannerStack";
import BannerListItem from "../BannerListItem/BannerListItem";

const withBanners = WrappedComponent => {
  return class extends Component {
    state = {
      banners: []
    };

    handleAddErrorBanner = message => {
      const banners = this.state.banners;
      banners.push(message);
      this.setState({ banners: banners });
    };

    handleBannerClose = index => {
      const banners = this.state.banners;

      banners.splice(index, 1);

      this.setState({
        banners: banners
      });
    };

    render() {
      return (
        <div>
          {this.state.banners.length > 0 && (
            <PageBannerStack>
              {this.state.banners.map((banner, index) => (
                <div>
                  <BannerListItem
                    warning
                    open={true}
                    onClose={() => this.handleBannerClose(index)}
                    key={banner}
                  >
                    {banner}
                  </BannerListItem>
                </div>
              ))}
            </PageBannerStack>
          )}
          <WrappedComponent
            {...this.props}
            addErrorBanner={this.handleAddErrorBanner}
          />
        </div>
      );
    }
  };
};
export default withBanners;
